/* tslint:disable */
/* eslint-disable */
/**
 * EXPItec API
 * The EXPItec API provides an interface to the EXPInet Reisesuche Frontend 
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CruiseAttribute
 */
export interface CruiseAttribute {
    /**
     * The id used to identify cruise attribute
     * @type {string}
     * @memberof CruiseAttribute
     */
    attributeId?: string;
    /**
     * The value of cruise attribute
     * @type {string}
     * @memberof CruiseAttribute
     */
    attributeValue?: string;
}

/**
 * Check if a given object implements the CruiseAttribute interface.
 */
export function instanceOfCruiseAttribute(value: object): value is CruiseAttribute {
    return true;
}

export function CruiseAttributeFromJSON(json: any): CruiseAttribute {
    return CruiseAttributeFromJSONTyped(json, false);
}

export function CruiseAttributeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CruiseAttribute {
    if (json == null) {
        return json;
    }
    return {
        
        'attributeId': json['attributeId'] == null ? undefined : json['attributeId'],
        'attributeValue': json['attributeValue'] == null ? undefined : json['attributeValue'],
    };
}

export function CruiseAttributeToJSON(json: any): CruiseAttribute {
    return CruiseAttributeToJSONTyped(json, false);
}

export function CruiseAttributeToJSONTyped(value?: CruiseAttribute | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'attributeId': value['attributeId'],
        'attributeValue': value['attributeValue'],
    };
}

